import React from 'react';
import pt from 'prop-types';

import Modal from 'components/modal';
import ListingCriteriaList from 'components/partners/listing-criteria';
import { LISTING_CRITERIA } from 'partners/shared/listing-criteria';

export default class ListingCriteria extends React.PureComponent {
  static contextTypes = {
    closeModal: pt.func.isRequired,
  };

  onClickClose = () => {
    this.context.closeModal();
  };

  render() {
    return (
      <Modal
        title="What to check before submitting"
        width={760}
        className="listing-criteria-modal"
        cancel={false}
        actions={[
          { label: 'Close', type: 'cancel', onClick: this.onClickClose },
        ]}
      >
        <ListingCriteriaList categories={LISTING_CRITERIA} />
      </Modal>
    );
  }
}
